import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton as MuiSkeleton, } from '@mui/material';
export function Skeleton({ animation = 'wave', ...props }) {
    return _jsx(MuiSkeleton, { ...props, animation: animation });
}
